import { useContext } from 'react'

import { HeadersContext } from '../HeadersContext'

export const useFullUrl = function useFullUrl() {
  return useContext(HeadersContext)
}
